// Fallback image map for services without an explicit imageUrl.
export const DEFAULT_IMAGE_MAP = {
  'basic maintenance': '/build/images/proposals/edging.webp',
  irrigation: '/build/images/proposals/sprinklers.webp',
  trimming: '/build/images/proposals/trimming_close.webp',
  'mowing (if applicable)': '/build/images/proposals/edging.webp',
  mowing: '/build/images/proposals/edging.webp',
  'weed control & pre-emergent': '/build/images/proposals/spray_close.webp',
  'weed control': '/build/images/proposals/spray_close.webp',
  'plant replacement': '/build/images/proposals/tree_trim_close.webp',
  fertilization: '/build/images/proposals/fertilizer_sm.webp',
  'pest control': '/build/images/proposals/pest_control.webp',
  'arbor care': '/build/images/proposals/tree_trim_close.webp',
}

export const getServiceImage = (svc) =>
  svc?.imageUrl || DEFAULT_IMAGE_MAP[svc?.name?.toLowerCase()] || ''
